import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useColors } from "@inbody/core";
import ButtonBase from "@mui/material/ButtonBase";
const HeaderIconButton = forwardRef(
  function HeaderIconButton2({ children, sx, ...rest }, ref) {
    const { gray, brand } = useColors();
    return /* @__PURE__ */ jsx(
      ButtonBase,
      {
        ref,
        ...rest,
        sx: {
          borderRadius: 1.5,
          padding: 0.75,
          color: gray[700],
          "&:hover": {
            backgroundColor: gray[50],
            color: brand[500]
          },
          ...sx
        },
        children
      }
    );
  }
);
export {
  HeaderIconButton
};
